import { Component, OnInit, ViewChild } from '@angular/core';
import {Module, AllCommunityModules } from '@ag-grid-community/all-modules';
import { EditButtonRendererComponent } from '../../renderer/edit-button-renderer.component';
import { DeleteButtonRendererComponent } from '../../renderer/delete-button-renderer.component';
import * as _ from 'lodash';
import { ModalDirective } from 'ngx-bootstrap/modal';
import * as moment from 'moment';
import { ConstantService } from '../../services/constant.service';
import { ApiService } from '../../services/api.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { HttpClient } from '@angular/common/http';
import { ImageRendererComponent } from '../../renderer/image-renderer.component';

@Component({
  selector: 'app-expenses',
  templateUrl: './expenses.component.html'
})
export class ExpensesComponent implements OnInit {
  @ViewChild('addDataModal') public addDataModal: ModalDirective;
  @ViewChild('deleteDataModal') public deleteDataModal: ModalDirective;
  @ViewChild('updateDataModal') public updateDataModal: ModalDirective;
  @ViewChild('deleteBulkComplainModal') public deleteBulkComplainModal: ModalDirective;
  @ViewChild('attachmentModal') public attachmentModal: ModalDirective;
  public gridApi;
  public gridColumnApi;
  public modules: Module[] = AllCommunityModules;
  public context;
  public frameworkComponents;
  public defaultColDef;
  public columnDefs;
  private permission;
  public selectedColony = [];
  public states;

  public rowSelection;
  _ = _;
  public userTypeList: any = [
    {typeCode: 'admin', permission: 'rwmd'},
    {typeCode: 'staff', permission: 'r'}
  ];
  maxDate = new Date();
  statusList: any = [];
  expenseHeadList: any = [];
  dataList = [];
  departments = [];
  newForm = {
    exp_date: "2022-01-06",
    head: "",
    username: "",
    narration: "",
    amount: "",
    approved: "",
    project: "",
    attachment: ""
  }

  alert = {
    type: 'info',
    msg: '',
    timeout: 5000
  }
  dropdownList = [];
  selectedItems = [];
  employeeListDropdown: any = [];
  dropdownSettings: IDropdownSettings = {};
  userList: any = [];
  filterParams: any = {dateRange: [moment().subtract(7, 'days').format(), moment().format()]};
  rowClassRules = {
    'rag-green': "data.approved === 'Yes'",
    'rag-amber': "data.approved === 'No'"
};
  constructor(private constantService:  ConstantService, private apiService: ApiService, private http: HttpClient) {

    this.permission = this.constantService.getCookies().PERMISSION;
    let permissionArray = this.permission.split('')
    this.context = { componentParent: this };
    this.defaultColDef = {
      sortable: true,
      filter: true,
      flex:0,
      resizable: true,
      floatingFilter: true,
    };
    this.frameworkComponents = {
      editButtonRenderer: EditButtonRendererComponent,
      deleteButtonRenderer : DeleteButtonRendererComponent,
      imageButtonRenderer : ImageRendererComponent,
    };
    this.states = this.constantService.getDataConstant('states');
    console.log(this.states);

    this.rowSelection = 'multiple';

    this.columnDefs = [
      { headerName: 'Srl No', field: 'srl_no', width: 150, filter: false,}
    ];
    _.each(_.keys(this.newForm), (field) => {
      this.columnDefs.push({ headerName: this.convertLabel(field), field: field, width: 200 })
    })
    this.columnDefs.push({ headerName: this.convertLabel('full_name'), field: 'full_name', width: 200 })
      this.columnDefs.push(
        { headerName: 'Attachment', field: 'value', cellRenderer: 'imageButtonRenderer', colId: 'paramsImg',  width: 60, filter: false, resizable: true, sortable: false,cellClass: ['text-center'], pinned: 'right'  },
        );

    if (_.includes(permissionArray, 'd')) {
      this.columnDefs.push({ headerName: 'Edit', field: 'value', cellRenderer: 'editButtonRenderer', colId: 'params',  width: 60, filter: false, resizable: true, sortable: false,cellClass: ['text-center'], pinned: 'right'  },
      // { headerName: 'Delete', field: 'value', cellRenderer: 'deleteButtonRenderer', colId: 'params1',  width: 60, filter: false, resizable: true, sortable: false,cellClass: ['text-center'], pinned: 'right'  },
      )
    }
   }

   headList: any = [];
  ngOnInit(): void {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true
    };
    // this.departments = this.profileService.getDepartment();
    // console.log(this.departments);
    this.listData();
    this.listProject();
    this.listUser();
    this.statusList =  [{item_id:'Yes', item_text: 'Yes'}, {item_id:'No', item_text: 'No'}];
    let document_list: any = [];
    this.headList = this.constantService.getDataConstant('expense_head');
    this.expenseHeadList = this.arrangeMultiselectData(this.headList, '', '');
  }
  listData() {

    this.filterParams.username = ((this.selectedUsername).map(item => "'" + item.item_id + "'")).join(',');
    this.filterParams.status = (((this.selectedStatus).map(item => "'" + item.item_id + "'")).join(','));
    this.filterParams.head = (((this.selectedHead).map(item => "'" + item.item_id + "'")).join(','));
    let queryString = "expense_manager.*, employees.full_name FROM `expense_manager`, employees WHERE expense_manager.exp_date BETWEEN '" + moment(this.filterParams.dateRange[0]).startOf('day').format('YYYY-MM-DD') + "' AND '" + moment(this.filterParams.dateRange[1]).endOf('day').format('YYYY-MM-DD') + "'";
    if(this.filterParams.username) queryString += " AND expense_manager.username IN (" + this.filterParams.username + ")";
    if(this.filterParams.status) queryString += " AND expense_manager.approved  IN (" + this.filterParams.status+ ")";
    if(this.filterParams.head) queryString += " AND expense_manager.head IN (" + this.filterParams.head + ")";
    queryString += " AND expense_manager.username = employees.phone_no";
    queryString += " ORDER BY expense_manager.srl_no DESC";
    this.apiService.getCustomData(btoa(queryString)).subscribe((resp: []) => {
      this.paginatedRecord = resp;
    })
  }
  projectList: any = [];
  listProject() {
    this.apiService.getData('project').then((resp: []) => {
      this.projectList = resp;
    })
  }

  listUser() {
    this.apiService.getData('employees').then((resp: []) => {
      this.userList = resp;
      this.employeeListDropdown = this.arrangeMultiselectData(resp, 'phone_no', 'full_name');
    })
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridColumnApi.moveColumn('full_name', 4);
  }
  selectedData: any = {};
  methodFromParent(userData) {
    this.selectedData = userData;
    console.log(this.selectedData, userData.action);
    if(userData.action === 'edit') {
      this.newForm = _.clone(this.selectedData);
      delete this.newForm['srl_no'];
      delete this.newForm['action'];
      delete this.newForm['timestamp'];
      delete this.newForm['full_name'];

      this.updateDataModal.show();
    }
    if(userData.action === 'delete') {
      this.deleteDataModal.show();
    }
    if(userData.action === 'image') {
      this.attachmentModal.show();
    }


  }

  savenewForm() {

    let duplicateRecord = this.checkForDuplicates(this.newForm);
    if(duplicateRecord) {
      this.alert.type = 'danger';
      this.alert.msg = 'Data already saved';
      setTimeout(() => {
        this.addDataModal.hide();
      this.alert.type = '';
        this.alert.msg = '';
      }, 2000)
    } else {

      this.apiService.addData('expense_manager', this.newForm).subscribe((resp) => {
        console.log(resp);
        this.resetForm();
        this.listData();
        this.alert.msg = 'Data has been successfully created.';
        setTimeout(() => {
          this.addDataModal.hide();
          this.alert.msg = '';
        }, 2000)
      })

    }


  }

  selectUserType(type) {
    if(type !== 'department') {
    }
  }
  resetForm() {
    this.newForm = {
      exp_date: "",
      username: "",
      narration: "",
      amount: "",
      head: "",
      approved: "",
      project: "",
      attachment: ""
    }
  }

  updateProfile() {
    let that = this;
    this.apiService.updateDetail('expense_manager', 'srl_no', this.selectedData.srl_no, this.newForm).subscribe((resp) => {
      console.log(resp);
      that.resetForm();
      that.listData();
      that.alert.msg = 'Data has been successfully updated.';
      setTimeout(() => {
        that.updateDataModal.hide();
        that.alert.msg = '';
      }, 2000)
    })
  }

  bulkUpload() {

  }
  onItemSelect(e) {
  }
  onItemDeSelect(e) {
  }
  onSelectAll(items: any) {
    console.log(items);
  }

  checkForDuplicates(data) {
    let filterData = _.filter(this.dataList, (item) => {
      return (item.phone_no).trim() === (data.phone_no).trim();
    })
    console.log(filterData);
    if (filterData.length > 0) {
      return filterData[0];
    } else {
      return null;
    }

  }

  convertLabel(label: string) {
    return label.replace(/_/g, ' ').toUpperCase();
  }


  formData  = new FormData();
  fileChange(index,event) {
    const file = event.target.files[0];
    const reader = new FileReader();
    let that = this;
    reader.readAsDataURL(file);
    reader.onload = () => {
        that.newForm.attachment = reader.result as string;
    };
  }
  arrangeMultiselectData(data, p1, p2) {
      let list: any = [];
      _.each(data, (item) => {
        list.push({ item_id: p1 ? item[p1] : item, item_text: p2 ? item[p2] : item})
      })
      console.log(list);
      let l = list
      return l;
  }

  records = [];
  paginatedRecord = [];
  paginaton = {
    totalItems: 0,
    currentPage: 1,
    maxSize: 100,
  }
  selectedUsername: any = [];
  selectedStatus: any = [];
  selectedHead: any = []
  searchReport() {
    this.records = [];this.paginatedRecord = [];
    console.log(this.filterParams.Department);
    this.filterParams.username = ((this.selectedUsername).map(item => "'" + item.item_id + "'")).join(',');
    this.filterParams.status = (((this.selectedStatus).map(item => "'" + item.item_id + "'")).join(','));
    this.filterParams.head = (((this.selectedHead).map(item => "'" + item.item_id + "'")).join(','));
    let queryString = "expense_manager.*, employees.full_name FROM `expense_manager`, employees WHERE expense_manager.exp_date BETWEEN '" + moment(this.filterParams.dateRange[0]).startOf('day').format('YYYY-MM-DD') + "' AND '" + moment(this.filterParams.dateRange[1]).endOf('day').format('YYYY-MM-DD') + "'";
    if(this.filterParams.username) queryString += " AND expense_manager.username IN (" + this.filterParams.username + ")";
    if(this.filterParams.status) queryString += " AND expense_manager.approved  IN (" + this.filterParams.status+ ")";
    if(this.filterParams.head) queryString += " AND expense_manager.head IN (" + this.filterParams.head + ")";
    queryString += " AND expense_manager.username = employees.phone_no";
    queryString += " ORDER BY expense_manager.srl_no DESC";
    console.log(queryString);
    this.apiService.getCustomData(btoa(queryString)).subscribe((resp: any) => {
      // console.log(resp);
      // _.each(resp, (e) => {
      //   e['complainNo'] = e.DepartmentCode + '/' + e.YearCode + '/' + e.srl_no + (e.ComplainCode? '/' : '') + e.ComplainCode;
      //   e['RegDate'] = moment(e.RegDate).format('YYYY-MM-DD');
      //   e['updatedAt'] = e.updatedAt && e.updatedAt  !== '0000-00-00 00:00:00' ? moment(e.updatedAt ).format('YYYY-MM-DD') : '';
      //   e['new_allotment_date'] = e.new_allotment_date && e.new_allotment_date  !== '0000-00-00' ? moment(e.new_allotment_date ).format('YYYY-MM-DD') : '';
      //   e['CompActualCloseDate'] = e.CompActualCloseDate && e.CompActualCloseDate  !== '0000-00-00 00:00:00' ? moment(e.CompActualCloseDate ).format('YYYY-MM-DD') : '';
      // })
      this.records = resp;
      this.paginaton.totalItems = this.records.length;
      // this.arrangeDataForExport(this.records);
      this.pageChanged({ page: 1, itemsPerPage: 100 });
    })
  }

  pageChanged(event): void {
    this.paginaton.currentPage = event.page;
    this.paginatedRecord = this.records.slice((this.paginaton.currentPage - 1) * this.paginaton.maxSize, this.paginaton.currentPage * this.paginaton.maxSize);
  }
}
